import React from 'react'

const SVGIconRenderer = ({ center, file, style }) => {
  const styles = {
    display: center ? 'block' : 'inline-block',
    margin: center ? 'auto' : '0',
    maxHeight: '30px',
    maxWidth: '30px',
    ...style
  }
  return <img src={file} style={styles} />
}

export default SVGIconRenderer
